import React from 'react';
import {
  Column,
  Columns,
  Button,
  Card,
} from '@codeparva/ui-components-library';
export const PayRentPaymentErrorScreen = ({
  setError,
  hideButton,
  setLoading,
  onTryAgain,
}: any) => {
  const defaultCallback = () => {
    setError(false);
    setLoading(false);
  };
  if (!onTryAgain) {
    onTryAgain = defaultCallback;
  }
  return (
    <Columns className="payRentErrorContainer">
      <Column className="is-half">
        <img
          src="https://tfw-v11-assets.s3.us-east-1.amazonaws.com/demo-website/storage.png"
          alt="hasError"
          placeholder="blurred"
          loading="lazy"
        />
      </Column>
      <Column className="is-half">
        <p className="mainTitle">Something Went Wrong</p>
        {hideButton === true ? (
          <></>
        ) : (
          <>
            <p className="subTitles">
              We couldn't complete the transaction. Please try it again
            </p>
            <p className="note">
              Note : If the transaction is still failing after 2 or 3 tries
              please try again in sometime.
            </p>

            <Button onClick={onTryAgain} className="tryAgainButton">
              Try Again
            </Button>
          </>
        )}
      </Column>
    </Columns>
  );
};

export const OtherPaymentErrorScreen = ({
  setError,
  hideButton,
  onTryAgain,
}: any) => {
  const defaultCallback = () => {
    setError(false);
  };
  if (!onTryAgain) {
    onTryAgain = defaultCallback;
  }
  return (
    <div className="errorContentContainer">
      <Card className="errorCard">
        <Column>
          <div className="errorCardHeader">
            <p>Something went wrong</p>
          </div>
          <div className="errorImageDiv">
            <img
              src="https://tfw-v11-assets.s3.us-east-1.amazonaws.com/demo-website/storage.png"
              alt="hasError"
              placeholder="blurred"
              loading="lazy"
            />
          </div>
          {hideButton === true ? (
            <></>
          ) : (
            <Button
              onClick={onTryAgain}
              className="tryAgainButton"
            >
              Try Again
            </Button>
          )}
        </Column>
      </Card>
    </div>
  );
};
